import axios, { AxiosRequestConfig } from "axios";

const basicAuthRoutes = [
  "login",
  "login/verify",
  "login/verifyMFASetup",
  "terms-and-conditions/accept",
  "tokens",
  "reset-password",
  "forgot-password",
  "forgot-password/verify",
  "register",
  "register/verify",
  "register/resend-code",
  "verify-email",
  "verify-recaptcha-token",
];

const setupAxiosAuth = (
  clientId: string,
  clientSecret: string,
  appUrl: string,
  railAuthApiUrl: string,
  { customAxiosInstance = null, history = null }: { customAxiosInstance?: any, history?: any }
) => {
  const axiosInstance = customAxiosInstance || axios;

  axiosInstance.interceptors.request.use(async (config: AxiosRequestConfig) => {
    const requestUrl = config?.url;
    config.withCredentials = true;
    const authenticated = localStorage.getItem("authenticated");
    if (authenticated && requestUrl !== "tokens") {
      let storedAuth = JSON.parse(authenticated);
      if (new Date(storedAuth.expireAt) < new Date()) {
        await refreshAccessToken(config, railAuthApiUrl, axiosInstance);
        storedAuth = JSON.parse(localStorage.getItem("authenticated"));
      }
      config.headers.authorization = `Bearer ${storedAuth.token}`;
    }

    if (
      basicAuthRoutes.includes(requestUrl) ||
      /^clients.*redirectUrl$/.test(requestUrl) ||
      /^clients.*termsAndCondCurrent$/.test(requestUrl)
    ) {
      const clientCredentials: string = btoa(`${clientId}:${clientSecret}`);
      config.headers.authorization = `Basic ${clientCredentials}`;
    }
    return config;
  });

  axiosInstance.interceptors.response.use(
    (response: any) => {
      return response;
    },
    (error: any) => {
      const originalRequest = error.config;
      const requestUrl: string = error?.config?.url;
      if ((requestUrl === "tokens" || requestUrl?.endsWith("/tokens")) && !originalRequest._retry) {
        localStorage.clear();

        let path = "/login?error=session_expired";
        if (history) {
          history.push(path);
        } else {
          window.location.href = appUrl + path;
        }

        return Promise.reject(error);
      }

      if (error.response?.status === 401 && !originalRequest._retry) {
        refreshAccessToken(originalRequest, railAuthApiUrl, axiosInstance);
      }
      return Promise.reject(error);
    }
  );
};

const refreshAccessToken = async (
  originalRequest: any,
  railAuthApiUrl: string,
  axiosInstance: any
) => {
  originalRequest._retry = true;
  const refreshToken: string | null = localStorage.getItem("refreshToken");
  if (refreshToken) {
    return axiosInstance
      .post(
        "tokens",
        {
          refreshToken: JSON.parse(refreshToken).token,
        },
        { baseURL: `${railAuthApiUrl}/api/` }
      )
      .then((refreshResponse: any) => {
        if (refreshResponse.status === 200) {
          localStorage.setItem("authenticated", JSON.stringify(refreshResponse.data.accessToken));
          localStorage.setItem("refreshToken", JSON.stringify(refreshResponse.data.refreshToken));
          localStorage.setItem("user", JSON.stringify(refreshResponse.data.user));
          return axiosInstance(originalRequest);
        }
        return null;
      });
  }
  return null;
};

export default setupAxiosAuth;
